<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useAuthStore } from '@/stores/useAuthStore'

const { t } = useI18n()
const { umsokn } = useUmsokn() // ref
const auth = useAuthStore()

const props = defineProps<{
  disable?: boolean
  handleNext?: () => void
  handlePrev?: () => void
}>()

// --- Validation ---
const rules = {
  umsokn: {
    confirmGrundvoll: { sameAs: sameAs(true) },
  },
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  },
})
</script>

<template>
  <div v-if="umsokn">
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('umsokn_tilgreind_sereign_step4_header') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <p>{{ t('umsokn_tilgreind_sereign_step4_text') }}</p>
        <p>{{ t('umsokn_tilgreind_sereign_step4_text2') }}</p>
        <p>{{ t('umsokn_tilgreind_sereign_step4_text3') }}</p>
        <p>{{ t('umsokn_tilgreind_sereign_step4_text4') }}</p>
        <p>{{ t('umsokn_tilgreind_sereign_step4_text5') }}</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.confirmGrundvoll"
          :label="t('umsokn_tilgreind_sereign_step4_confirm')"
          :readonly="props.disable"
          density="comfortable"
          :error="v$.umsokn.confirmGrundvoll.$error"
          :error-messages="
            v$.umsokn.confirmGrundvoll.$error
              ? [t('umsokn_tilgreind_sereign_step4_confirm_error')]
              : []
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
input {
  width: 100%;
}
.forms__fadein {
  opacity: 0;
  -moz-transition: opacity 0.4s ease-in-out;
  -o-transition: opacity 0.4s ease-in-out;
  -webkit-transition: opacity 0.4s ease-in-out;
  transition: opacity 0.4s ease-in-out;
}
.forms__fadeout {
  opacity: 1;
}
.slideup,
.slidedown {
  max-height: 0;
  overflow: hidden;
  width: 100%;
  -webkit-transition: max-height 0.8s ease-in-out;
  -moz-transition: max-height 0.8s ease-in-out;
  -o-transition: max-height 0.8s ease-in-out;
  transition: max-height 0.8s ease-in-out;
}

.slidedown {
  max-height: 500px;
}
</style>
